import { cn } from '@invent/wl-ui-kit-next';
import { Button, Popover, PopoverContent, PopoverTrigger } from '@invent/wl-ui-kit-next/ui';
import { CircleHelp } from 'lucide-react';
import * as React from 'react';

/**
 * A "?" that opens what a thing is and how it works (SR-474) — the explanation a newcomer needs and
 * a regular reader does not, kept one press away rather than as a line on the screen. **Only an
 * explanation goes behind it**: what is true now — why a button is off, what a registry answered —
 * stays on the screen, where it is read without asking. Never a `title`, which neither a keyboard
 * nor a screenshot reaches. The popover is named as its button is, so a spec finds it by the words
 * the button says.
 */
export function HelpPopover({
  label,
  align = 'start',
  className,
  children
}: {
  /** The button's accessible name, "About <what it explains>". */
  label: string;
  align?: 'start' | 'center' | 'end';
  className?: string;
  children: React.ReactNode;
}) {
  return (
    <Popover>
      <PopoverTrigger asChild>
        <Button
          type="button"
          variant="ghost"
          size="icon"
          className={cn('-my-1 size-7 text-muted-foreground', className)}
          aria-label={label}
        >
          <CircleHelp className="size-4" aria-hidden />
        </Button>
      </PopoverTrigger>
      <PopoverContent align={align} aria-label={label} className="grid max-w-sm gap-2 text-sm">
        {children}
      </PopoverContent>
    </Popover>
  );
}
